module.exports = __webpack_public_path__ + "static/media/abn-badge.eb4863fd.png";